import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ScrollableContainer from '../../../../utility/ScrollableContainer';
import LandUse from './LandUse';
import ResidentialValue from './ResidentialValue';

class Value extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes } =this.props;

        return (
            <ScrollableContainer>
                <div className={classes.root}>
                    <LandUse />
                    <ResidentialValue />
                </div>
            </ScrollableContainer>
        );
    }
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    }
});

export default withStyles(style)(Value);